import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText, FormGroup, Label, Input, CloseButton, Spinner } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { ITopic } from 'app/shared/model/topic.model';
import { getEntities as getTopics } from 'app/entities/topic/topic.reducer';
import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/shared/reducers/user-management';
import { IInspiration } from 'app/shared/model/inspiration.model';
import { getEntity, updateEntity, reset, createEntityinspirations } from 'app/entities/inspiration/inspiration.reducer';
import axios from 'axios';
import { checkValid, renderPreview } from 'app/shared/common-fun';
import Select, { components } from 'react-select';

const Option = props => (
  <components.Option {...props}>
    <input type="checkbox" checked={props.isSelected} onChange={() => null} style={{ marginRight: 8 }} />
    <label>{props.label}</label>
  </components.Option>
);
export const InspirationUpdate = props => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const id = props.inspirationId;
  const isNew = id === null;
  const topics = useAppSelector(state => state.topic.entities);
  const users = useAppSelector(state => state.userManagement.users);
  const inspirationEntityData = useAppSelector(state => state.inspiration.entity);
  const [inspirationEntity, setInspirationEntity] = useState<IInspiration | null>(null);
  const loading = useAppSelector(state => state.inspiration.loading);
  const [error, setError] = useState('');
  const [inspiration, setInspiration] = useState('');
  const [apiError, setApiError] = useState('');
  const updating = useAppSelector(state => state.inspiration.updating);
  const updateSuccess = useAppSelector(state => state.inspiration.updateSuccess);
  const [imagePreview, setImagePreview] = useState('');
  const [uploadedImage, setUploadedImage] = useState(null);
  const account = useAppSelector(state => state.authentication.account);
  const userid = account.id;

  const [inspirationTopics, setInspirationTopics] = useState([]);
  const [allTopics, setAllTopics] = useState([]);
  const [imageName, setImageName] = useState(null);
  const [uploading, setUploading] = useState(false);

  const topicOptions = allTopics.map(topic => ({
    value: topic.id,
    label: topic.name,
  }));

  const handleClose = () => {
    props.handleSubmit();
  };

  useEffect(() => {
    if (isNew) {
    } else {
      if (Array.isArray(inspirationEntityData)) {
        const inspirationEntityArray = inspirationEntityData.filter(item => item.id === id) as IInspiration[];
        if (inspirationEntityArray.length > 0) {
          setInspirationEntity(inspirationEntityArray[0]);
        }
      }
    }
  }, [isNew, id, inspirationEntityData]);

  useEffect(() => {
    dispatch(getTopics({ page: 0, size: 100, sort: 'id,asc' }));
  }, []);

  useEffect(() => {
    if (topics) {
      setAllTopics(topics);
    }
  }, [topics]);

  useEffect(() => {
    if (inspirationEntity?.imageName) {
      setImagePreview(inspirationEntity?.imageName);
      setImageName(inspirationEntity?.imageName);
    }
    if (inspirationEntity?.description) {
      setInspiration(inspirationEntity?.description);
    }
    if (!isNew && inspirationEntity && inspirationEntity.topics) {
      const selectedTopicNames = inspirationEntity.topics.split(', ').map(topic => topic.trim());

      const selectedTopics = allTopics
        .filter(topic => selectedTopicNames.includes(topic.name))
        .map(topic => ({ value: topic.id, label: topic.name }));

      setInspirationTopics(selectedTopics);
    }
  }, [inspirationEntity, allTopics]);

  const handleFileInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const errorMsg = checkValid(event);
    if (errorMsg) {
      setError(errorMsg);
      return;
    }
    setApiError('');
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const formData = new FormData();
      formData.append('image', selectedFile);
      setUploading(true);
      axios
        .post('/api/upload', formData)
        .then(response => {
          setImagePreview(response.data);
          setImageName(response.data);
          setUploadedImage(response.data);
          setError('');
        })
        .catch(error => {
          console.error('Error uploading image:', error);
          setError('Error uploading image. Please try again.');
        })
        .finally(() => setUploading(false));
    }
  };

  const handleRemoveImage = () => {
    setImagePreview('');
    setUploadedImage(null);
    setImageName('');
  };

  const handleTopicSelect = selectedOptions => {
    setInspirationTopics(selectedOptions || []); // guard against null when all cleared
  };

  const saveEntity = async values => {
    values.createdDate = convertDateTimeToServer(values.createdDate);
    values.modifiedDate = convertDateTimeToServer(values.modifiedDate);

    const topicsString = inspirationTopics.map(opt => opt.label).join(', ');

    if (!imageName && !values.link?.trim()) {
      setApiError('Please choose an image or enter a link. At least one is required');
      return;
    }

    setApiError('');

    const entity = {
      ...inspirationEntity,
      ...values,
      description: inspiration,
      imageName: imageName !== '' ? imageName || inspirationEntity?.imageName : null,
      topics: topicsString,
      user: { id: userid },
      approved: false,
    };

    if (isNew) {
      const resultAction = await dispatch(createEntityinspirations(entity));
      if (createEntityinspirations.fulfilled.match(resultAction)) {
        handleClose();
      } else if (createEntityinspirations.rejected.match(resultAction)) {
        const errorMessage = resultAction.payload as string;
        if (errorMessage) {
          setApiError(errorMessage);
        }
      }
    } else {
      await dispatch(updateEntity(entity));
      handleClose();
    }
  };

  const handleInspirationChange = value => {
    if (value.split(' ').length <= 50) {
      setInspiration(value);
      setError('');
    } else {
      setError('Only 50 words are allowed in inspiration');
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          createdDate: new Date(),
          modifiedDate: displayDefaultDateTime(),
        }
      : {
          ...inspirationEntity,
          description: inspiration,
          modifiedDate: convertDateTimeFromServer(new Date()),
          imageName: imageName !== '' ? imageName || inspirationEntity?.imageName : null,
          user: inspirationEntity?.user?.id,
        };

  return (
    <div className="card meeting-border edit-create-pages">
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fivePlusApp.inspiration.home.createOrEditLabel" data-cy="InspirationCreateUpdateHeading">
            <label>Create or edit an Inspiration</label>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <Spinner className="body-loader-icon"></Spinner>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              <FormGroup>
                <Label for="inspiration-description">
                  {translate('fivePlusApp.inspiration.description')}
                  <span className="text-danger"> *</span>
                </Label>
                <ValidatedField
                  id="inspiration-description"
                  name="description"
                  data-cy="description"
                  type="textarea"
                  value={inspiration}
                  onChange={e => handleInspirationChange(e.target.value)}
                  placeholder={`Enter your inspiration (max 50 words)`}
                  required
                />
                {error && <div className="text-danger">{error}</div>}
              </FormGroup>
              <ValidatedField
                id="images-file"
                name="imageName"
                data-cy="imageName"
                type="file"
                label={'Choose File'}
                className="col-12 col-md-6 col-lg-4 position-raelative"
                onChange={handleFileInputChange}
                valid={false}
              />
              <Col md={12} className="mb-3">
                <div className="d-flex flex-wrap align-items-center gap-2 small text-muted">
                  <span>
                    <FontAwesomeIcon icon="info-circle" className="me-1" />
                    Supported files:
                  </span>
                  <span
                    className="badge rounded-pill"
                    style={{ backgroundColor: '#e7f1ff', color: '#0d6efd', border: '1px solid #0d6efd' }}
                  >
                    Images: JPG, JPEG, PNG, GIF, WEBP
                  </span>
                  <span
                    className="badge rounded-pill"
                    style={{ backgroundColor: '#fdeaea', color: '#dc3545', border: '1px solid #dc3545' }}
                  >
                    PDF
                  </span>
                  <span
                    className="badge rounded-pill"
                    style={{ backgroundColor: '#e6f6ec', color: '#198754', border: '1px solid #198754' }}
                  >
                    Video/Audio: MP4, MOV, WEBM, OGG, AVI, MKV, MP3
                  </span>
                  <span
                    className="badge rounded-pill"
                    style={{ backgroundColor: '#eef0f2', color: '#6c757d', border: '1px solid #6c757d' }}
                  >
                    Max 50MB
                  </span>
                </div>
              </Col>
              {uploading && <Spinner className="body-loader-icon" />}
              {!isNew ? (
                <Col md={12}>
                  {imageName ? (
                    <div className="remove-img-btn">
                      <CloseButton onClick={handleRemoveImage} />
                      {renderPreview(imageName)}
                    </div>
                  ) : null}
                </Col>
              ) : imagePreview ? (
                <Col md={12}>
                  <div className="remove-img-btn">
                    <CloseButton onClick={handleRemoveImage} />
                  </div>
                  {renderPreview(imagePreview)}
                </Col>
              ) : null}
              <div className="align-items-center d-flex form-title pb-1">
                <h3 className="pt-3">Topics</h3> <hr className="w-100 m-0 ms-3" />
              </div>
              <div id="topic-ques" className="mb-3">
                <Select
                  options={topicOptions} // { value: id, label: name }[]
                  isMulti // enables multi-select
                  closeMenuOnSelect={false} // keeps dropdown open after selection
                  hideSelectedOptions={false} // hides already-selected options from list
                  components={{ Option }} // uses custom checkbox-style Option
                  onChange={handleTopicSelect} // updates inspirationTopics state
                  value={inspirationTopics} // controlled: shows current selections
                  placeholder="Select topics..."
                />
              </div>
              <ValidatedField
                label={translate('fivePlusApp.inspiration.link')}
                id="inspiration-link"
                name="link"
                data-cy="link"
                type="text"
                onChange={() => {
                  if (apiError) {
                    setApiError('');
                  }
                }}
                validate={{
                  pattern: {
                    value: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/,
                    message: 'Please enter a valid URL',
                  },
                }}
                valid={false}
              />
              {apiError && <div className="text-danger small mb-2">{apiError}</div>}
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Submit</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default InspirationUpdate;
